<style scoped>
</style>

<template>
  <div>
    <Content :style="{background: '#fff',padding:'15px',margin:'10px'}">
      <Button icon="md-add" @click="showAddAppModal" type="primary">添加应用</Button>
      <Button style="margin-left:10px" @click="deleteSelection" type="primary">删除选中</Button>
      <Table
        @on-selection-change="selectChange"
        stripe
        :columns="tdata.col_data"
        :data="tdata.current_data"
        :loading="tdata.loading"
        style="margin-top:10px"
      >
        <template slot-scope="{row}" slot="update">
          <Button @click="rowSelect(row)" size="small">修改</Button>
        </template>
        <template slot-scope="{row}" slot="copyid">
          <Button @click="copyid(row)" size="small">复制</Button>
        </template>
        <template slot-scope="{row}" slot="isterminate">
          <i-switch
            v-model="row.isterminate"
            :true-value="1"
            :false-value="0"
            @on-change="terminateChange(row)"
          />
        </template>
      </Table>
    </Content>
    <Modal v-model="addAppModal.modal" title="新增应用" @on-visible-change="addAppModalVisible">
      <Form :model="addAppModal.addAppModel" :label-width="80">
        <FormItem label="平台">
          <!-- <Select v-model="addAppModal.addAppModel.platform">
            <Option
              v-for="item in dict.platformItems"
              :value="item.itemvalue"
              :key="item.id"
            >{{ item.itemtext }}</Option>
          </Select>-->
          <iradiogroup dictcode="dev_type" v-model="addAppModal.addAppModel.platform"></iradiogroup>
        </FormItem>
        <FormItem label="应用名称">
          <Input v-model="addAppModal.addAppModel.appname" />
        </FormItem>
        <FormItem label="应用包名" v-if="addAppModal.addAppModel.platform!='h5'">
          <Input v-model="addAppModal.addAppModel.appid" />
        </FormItem>
        <FormItem label="svn地址">
          <Input v-model="addAppModal.addAppModel.svnaddress" />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" size="large" @click="addCancel">取消</Button>
        <Button type="primary" size="large" @click="addSubmit">确定</Button>
      </div>
    </Modal>
    <Modal v-model="editAppModal.modal" title="编辑应用" @on-visible-change="editAppModalVisible">
      <Form :model="editAppModal.model" :label-width="80">
        <FormItem label="平台">
          <iradiogroup dictcode="dev_type" v-model="editAppModal.model.platform"></iradiogroup>
        </FormItem>
        <FormItem label="应用名称">
          <Input v-model="editAppModal.model.appname" />
        </FormItem>
        <FormItem label="应用包名" v-if="editAppModal.model.platform!='h5'">
          <Input v-model="editAppModal.model.appid" />
        </FormItem>
        <FormItem label="svn地址">
          <Input v-model="editAppModal.model.svnaddress" />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" size="large" @click="editCancel">取消</Button>
        <Button type="primary" size="large" @click="editSubmit">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import iradiogroup from "../../components/iradiogroup";
export default {
  components: { iradiogroup },
  data() {
    return {
      selection: [],
      projectguid: this.$route.params.projectguid,
      editAppModal: {
        modal: false,
        model: {
          appname: "",
          appid: "",
          platform: "",
          projectguid: "",
          svnaddress: ""
        }
      },
      addAppModal: {
        modal: false,
        addAppModel: {
          appname: "",
          appid: "",
          platform: "",
          projectguid: "",
          svnaddress: ""
        }
      },
      tdata: {
        //是否显示loading框
        loading: false,
        //当前表格数据
        current_data: [],
        //表头数据
        col_data: [
          {
            type: "selection",
            width: 60,
            align: "center"
          },
          {
            type: "index",
            width: 60,
            align: "center"
          },
          {
            title: "ID",
            key: "id",
            width: 250
          },
          {
            title: " ",
            slot: "copyid",
            width: 80
          },
          {
            title: "应用名称",
            key: "appname",
            width: 200
          },
          {
            title: "平台",
            key: "platform",
            width: 80
          },
          {
            title: "应用包名",
            key: "appid",
            width: 250
          },

          {
            title: "svn",
            key: "svnaddress"
          },
          {
            title: "操作",
            slot: "update",
            width: 100
          },
          {
            title: "终止维护",
            slot: "isterminate",
            width: 100
          }
        ]
      },
      dict: {
        platformItems: []
      }
    };
  },
  methods: {
    terminateChange(row) {
      let _this = this;
      this.$http.post({
        method: "mqms/app/updateterminate",
        params: {
          id: row.id,
          isterminate: row.isterminate
        },
        success: function(data) {
          _this.getAppList();
        },
        failure(code, msg) {
          _this.getAppList();
          _this.$Message.warning({
            title: "提示",
            content: msg
          });
        }
      });
    },
    deleteSelection() {
      let ids = [];
      for (let i = 0; i < this.selection.length; i++) {
        ids.push(this.selection[i].id);
      }
      if (ids.length == 0) {
        this.$Message.warning("请选中至少一项");
        return;
      }

      let _this = this;

      this.$Modal.confirm({
        title: "提示",
        content: "确定要删除吗？",
        onOk: () => {
          _this.$http.post({
            method: "mqms/app/deleteBatch",
            params: ids,
            success: function(data) {
              _this.getAppList();
            },
            failure(code, msg) {
              _this.$Message.warning({
                title: "提示",
                content: msg
              });
            }
          });
        }
      });
    },
    selectChange(selection) {
      this.selection = selection;
    },
    addCancel() {
      this.addAppModal.modal = false;
    },
    addSubmit() {
      let _this = this;
      this.addAppModal.addAppModel.projectguid = this.projectguid;
      this.$http.post({
        method: "mqms/app/add",
        params: this.addAppModal.addAppModel,
        success: function(data) {
          _this.addAppModal.modal = false;
          _this.getAppList();
        },
        failure(code, msg) {
          _this.$Message.warning({
            title: "提示",
            content: msg
          });
        }
      });
    },
    editCancel() {
      this.editAppModal.modal = false;
    },
    editSubmit() {
      let _this = this;
      this.$http.post({
        method: "mqms/app/update",
        params: this.editAppModal.model,
        success: function(data) {
          _this.$Message.success({
                content: "修改成功"
              });
          _this.editAppModal.modal = false;
          _this.getAppList();
        },
        failure(code, msg) {
          _this.$Message.warning({
            title: "提示",
            content: msg
          });
        }
      });
    },
    addAppModalVisible() {
      this.addAppModal.addAppModel = {};
    },
    editAppModalVisible(visible) {
      if (!visible) {
        this.editAppModal.model = {};
      }
    },
    showAddAppModal() {
      this.addAppModal.modal = true;
    },
    getAppList() {
      let _this = this;
      this.$http.get({
        method: "mqms/app/list",
        params: {
          projectguid: this.projectguid
        },
        success: function(data) {
          _this.tdata.current_data = data;
        },
        failure(code, msg) {}
      });
    },
    rowSelect(row) {
      this.editAppModal.modal = true;
      this.editAppModal.model = row;
    },
    copyid(row) {
      var input = document.createElement("input"); // 创建input对象
      input.value = row.id; // 设置复制内容
      document.body.appendChild(input); // 添加临时实例
      input.select(); // 选择实例内容
      document.execCommand("Copy"); // 执行复制
      document.body.removeChild(input); // 删除临时实例
      this.$Message.success({
          title: "提示",
          content: "复制成功"
      });
    },
    init() {
      //获取平台类型
      let _this = this;
      this.$http.get({
        method: "base/dictitem/listbydictcode",
        params: {
          dictcode: "dev_type"
        },
        success: function(data) {
          _this.dict.platformItems = data;
        },
        failure(code, msg) {}
      });
    }
  },
  mounted() {
    this.init();
    this.getAppList();
  }
};
</script>